import ContentMainComponent from 'primitives/Layout/ContentMain';
import styled from '@emotion/styled';

const ContentMain = styled(ContentMainComponent)({
  marginTop: 0,
});

export default ContentMain;
